import React from "react";

const Consultation = () => {
  return (
    <section className="bg-white py-14 sm:py-20">
      <div className="mx-auto grid max-w-7xl gap-0 px-5 lg:grid-cols-[.8fr_1.2fr] lg:px-8">
      <div className="bg-teal-800 p-7 text-white sm:p-10 lg:rounded-l-lg">
        <p className="text-xs font-bold uppercase tracking-[.2em] text-teal-200">Talk to our team</p>
        <h2 className="mt-3 text-2xl font-bold sm:text-3xl">Need a consultation?</h2>
        <p className="mt-4 leading-7 text-teal-50">
          Contact our customer support team if you have any further questions.
          We are here to help you out
        </p>
        <a className="mt-8 block break-all text-lg font-semibold hover:text-teal-200" href="mailto:support@lumetrasoftech.in">support@lumetrasoftech.in</a>
      </div>
      <div className="border border-l-0 border-slate-200 bg-slate-50 p-7 sm:p-10 lg:rounded-r-lg">
        <h2 className="text-3xl font-bold text-slate-900 sm:text-4xl">
          Crafting Digital Experiences
        </h2>
        <p className="mt-5 max-w-2xl leading-8 text-slate-600">
          Our team of talented developers, designers, and strategists bring a
          diverse blend of experience and expertise, creating websites that not
          only look stunning but function seamlessly. We delve deep into
          understanding your business goals to create a custom web solution that
          sets you apart from the competition.
        </p>
      </div>
      </div>
    </section>
  );
};

export default Consultation;
